(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cel-split-hero-mint"] && !Shopify.designMode) return;
  try {
    

  (() => {

    if (
      customElements.get(
        'cel-split-hero'
      )
    ) {
      return;
    }


    class CelSplitHero extends HTMLElement {

      connectedCallback() {

        if (this._initialized) {
          return;
        }

        this._initialized = true;

        this.init();
      }


      disconnectedCallback() {

        this.destroy();
      }


      init() {

        this.slides =
          Array.from(
            this.querySelectorAll(
              '[data-slide]'
            )
          );


        this.count =
          this.slides.length;


        if (!this.count) {
          return;
        }


        this.index =
          Math.max(
            0,
            this.slides.findIndex(
              (slide) =>
                slide.classList.contains(
                  'is-active'
                )
            )
          );


        this.delay =
          Math.max(
            2500,
            Number.parseInt(
              this.dataset.delay ||
              '5000',
              10
            ) || 5000
          );


        this.videoAdvanceMode =
          this.dataset.videoAdvance ||
          'video_time';


        this.videoPlaysBeforeAdvance =
          Math.max(
            1,
            Math.min(
              3,
              Number.parseInt(
                this.dataset.videoPlays ||
                '1',
                10
              ) || 1
            )
          );


        this.autoplayInEditor =
          this.dataset.autoplayEditor === 'true';


        this.pauseOnHover =
          this.dataset.pauseHover === 'true';


        this.pauseOnFocus =
          this.dataset.pauseFocus === 'true';


        this.reducedMotion =
          window.matchMedia?.(
            '(prefers-reduced-motion: reduce)'
          ).matches || false;


        this.designMode =
          Boolean(
            window.Shopify &&
            Shopify.designMode
          );


        this.autoplayEnabled =
          this.dataset.autoplay === 'true'
          &&
          !this.reducedMotion
          &&
          this.count > 1
          &&
          (
            !this.designMode
            ||
            this.autoplayInEditor
          );


        this.userPaused = false;

        this.hoverPaused = false;

        this.focusPaused = false;


        this.inView =
          !(
            'IntersectionObserver'
            in window
          );


        this.timer = null;

        this.videoDurationTimer = null;


        this.pointerStartX = null;

        this.pointerStartY = null;


        this.prevButton =
          this.querySelector(
            '[data-prev]'
          );


        this.nextButton =
          this.querySelector(
            '[data-next]'
          );


        this.dotsWrap =
          this.querySelector(
            '[data-dots]'
          );


        this.autoplayToggle =
          this.querySelector(
            '[data-autoplay-toggle]'
          );


        this.buildDots();

        this.bindVideoState();

        this.updateAutoplayButton();

        this.setActive(
          this.index,
          false
        );


        this._onClick =
          this.onClick.bind(this);


        this._onMouseEnter =
          () => {

            if (!this.pauseOnHover) {
              return;
            }

            this.hoverPaused = true;

            this.stopTimer();
          };


        this._onMouseLeave =
          () => {

            if (!this.pauseOnHover) {
              return;
            }

            this.hoverPaused = false;

            this.startTimer();
          };


        this._onFocusIn =
          () => {

            if (!this.pauseOnFocus) {
              return;
            }

            this.focusPaused = true;

            this.stopTimer();
          };


        this._onFocusOut =
          (event) => {

            if (!this.pauseOnFocus) {
              return;
            }

            if (
              !this.contains(
                event.relatedTarget
              )
            ) {

              this.focusPaused = false;

              this.startTimer();
            }
          };


        this._onVisibility =
          () => {

            if (document.hidden) {

              this.stopTimer();

              this.pauseAllVideos();

            } else {

              this.startTimer();

              this.playActiveVideo();
            }
          };


        this._onPointerDown =
          this.onPointerDown.bind(this);


        this._onPointerUp =
          this.onPointerUp.bind(this);


        this._onBlockSelect =
          this.onBlockSelect.bind(this);


        this.addEventListener(
          'click',
          this._onClick
        );


        this.addEventListener(
          'mouseenter',
          this._onMouseEnter
        );


        this.addEventListener(
          'mouseleave',
          this._onMouseLeave
        );


        this.addEventListener(
          'focusin',
          this._onFocusIn
        );


        this.addEventListener(
          'focusout',
          this._onFocusOut
        );


        this.addEventListener(
          'pointerdown',
          this._onPointerDown,
          {
            passive: true
          }
        );


        this.addEventListener(
          'pointerup',
          this._onPointerUp,
          {
            passive: true
          }
        );


        this.addEventListener(
          'shopify:block:select',
          this._onBlockSelect
        );


        document.addEventListener(
          'visibilitychange',
          this._onVisibility
        );


        if (
          'IntersectionObserver'
          in window
        ) {

          this.observer =
            new IntersectionObserver(
              (entries) => {

                const entry =
                  entries[0];


                this.inView =
                  Boolean(
                    entry &&
                    entry.isIntersecting
                  );


                if (this.inView) {

                  this.startTimer();

                  this.playActiveVideo();

                } else {

                  this.stopTimer();

                  this.pauseAllVideos();

                }

              },
              {
                threshold: 0.15
              }
            );


          this.observer.observe(this);
        }


        if (
          this.reducedMotion ||
          this.designMode
        ) {

          if (this.autoplayToggle) {

            this.autoplayToggle.hidden =
              true;
          }
        }


        this.startTimer();

        this.playActiveVideo();
      }


      destroy() {

        this.stopTimer();

        this.pauseAllVideos();

        this.observer?.disconnect();


        if (this._videoStateHandlers) {

          this._videoStateHandlers.forEach(
            ({
              video,
              markPlaying,
              showPoster,
              restartTimerOnMetadata
            }) => {

              video.removeEventListener(
                'playing',
                markPlaying
              );

              video.removeEventListener(
                'waiting',
                showPoster
              );

              video.removeEventListener(
                'emptied',
                showPoster
              );

              video.removeEventListener(
                'error',
                showPoster
              );


              if (restartTimerOnMetadata) {

                video.removeEventListener(
                  'loadedmetadata',
                  restartTimerOnMetadata
                );
              }
            }
          );


          this._videoStateHandlers = [];
        }


        if (this._onClick) {

          this.removeEventListener(
            'click',
            this._onClick
          );
        }


        if (this._onMouseEnter) {

          this.removeEventListener(
            'mouseenter',
            this._onMouseEnter
          );
        }


        if (this._onMouseLeave) {

          this.removeEventListener(
            'mouseleave',
            this._onMouseLeave
          );
        }


        if (this._onFocusIn) {

          this.removeEventListener(
            'focusin',
            this._onFocusIn
          );
        }


        if (this._onFocusOut) {

          this.removeEventListener(
            'focusout',
            this._onFocusOut
          );
        }


        if (this._onPointerDown) {

          this.removeEventListener(
            'pointerdown',
            this._onPointerDown
          );
        }


        if (this._onPointerUp) {

          this.removeEventListener(
            'pointerup',
            this._onPointerUp
          );
        }


        if (this._onBlockSelect) {

          this.removeEventListener(
            'shopify:block:select',
            this._onBlockSelect
          );
        }


        if (this._onVisibility) {

          document.removeEventListener(
            'visibilitychange',
            this._onVisibility
          );
        }


        this._initialized = false;
      }


      buildDots() {

        if (!this.dotsWrap) {
          return;
        }


        this.dotsWrap.replaceChildren();


        this.slides.forEach(
          (_, index) => {

            const button =
              document.createElement(
                'button'
              );


            button.type =
              'button';


            button.className =
              'dot';


            button.dataset.dotIndex =
              String(index);


            button.setAttribute(
              'aria-label',
              `Zu Slide ${index + 1}`
            );


            button.setAttribute(
              'aria-current',
              index === this.index
                ? 'true'
                : 'false'
            );


            this.dotsWrap.appendChild(
              button
            );
          }
        );
      }


      bindVideoState() {

        this._videoStateHandlers = [];


        this.querySelectorAll(
          '[data-csh-video]'
        ).forEach(
          (video) => {

            const media =
              video.closest(
                '.csh__media'
              );


            if (!media) {
              return;
            }


            const markPlaying =
              () => {

                media.classList.add(
                  'is-video-playing'
                );
              };


            const showPoster =
              () => {

                media.classList.remove(
                  'is-video-playing'
                );
              };


            const restartTimerOnMetadata =
              () => {

                if (
                  this.getActiveVideo() === video
                ) {

                  this.startTimer();
                }
              };


            video.addEventListener(
              'playing',
              markPlaying
            );


            video.addEventListener(
              'waiting',
              showPoster
            );


            video.addEventListener(
              'emptied',
              showPoster
            );


            video.addEventListener(
              'error',
              showPoster
            );


            video.addEventListener(
              'loadedmetadata',
              restartTimerOnMetadata
            );


            this._videoStateHandlers.push(
              {
                video,
                markPlaying,
                showPoster,
                restartTimerOnMetadata
              }
            );
          }
        );
      }


      getActiveVideo() {

        return (
          this.slides[
            this.index
          ]?.querySelector(
            '[data-csh-video]'
          ) || null
        );
      }


      shouldUseVideoDuration(video) {

        return (
          Boolean(video)
          &&
          this.videoAdvanceMode === 'video_time'
        );
      }


      getActiveDelay() {

        const video =
          this.getActiveVideo();


        if (
          this.shouldUseVideoDuration(video)
        ) {

          const durationMs =
            Number.isFinite(video.duration)
            &&
            video.duration > 0.5
              ? video.duration * 1000
              : this.delay;


          return Math.max(
            2500,
            Math.min(
              180000,
              Math.round(
                durationMs * this.videoPlaysBeforeAdvance
              ) + 250
            )
          );
        }


        return this.delay;
      }


      setActive(
        nextIndex,
        restartAutoplay = true
      ) {

        if (!this.count) {
          return;
        }


        this.index =
          (
            nextIndex +
            this.count
          )
          %
          this.count;


        this.slides.forEach(
          (slide, index) => {

            const active =
              index === this.index;


            slide.classList.toggle(
              'is-active',
              active
            );


            slide.setAttribute(
              'aria-hidden',
              active
                ? 'false'
                : 'true'
            );
          }
        );


        this.querySelectorAll(
          '[data-dot-index]'
        ).forEach(
          (dot) => {

            dot.setAttribute(
              'aria-current',
              Number(
                dot.dataset.dotIndex
              )
              ===
              this.index
                ? 'true'
                : 'false'
            );
          }
        );


        this.pauseAllVideos();


        const activeVideo =
          this.getActiveVideo();


        if (activeVideo) {

          activeVideo.loop = true;

          try {

            activeVideo.currentTime = 0;

          } catch (_) {}
        }


        this.playActiveVideo();


        if (restartAutoplay) {

          this.stopTimer();

          this.startTimer();
        }
      }


      canAutoplay() {

        return (
          this.autoplayEnabled
          &&
          !this.userPaused
          &&
          !this.hoverPaused
          &&
          !this.focusPaused
          &&
          this.inView
          &&
          !document.hidden
        );
      }


      startTimer() {

        this.stopTimer();


        if (!this.canAutoplay()) {
          return;
        }


        this.timer =
          window.setTimeout(
            () => {

              this.setActive(
                this.index + 1,
                false
              );


              this.startTimer();

            },
            this.getActiveDelay()
          );
      }


      stopTimer() {

        if (this.timer) {

          window.clearTimeout(
            this.timer
          );


          this.timer = null;
        }
      }


      pauseAllVideos() {

        this.querySelectorAll(
          '[data-csh-video]'
        ).forEach(
          (video) => {

            try {

              video.pause();

            } catch (_) {}
          }
        );
      }


      playActiveVideo() {

        if (
          document.hidden
          ||
          !this.inView
          ||
          this.reducedMotion
        ) {
          return;
        }


        const video =
          this.getActiveVideo();


        if (!video) {
          return;
        }


        video.muted = true;

        video.playsInline = true;

        video.loop = true;


        if (
          !video.paused
          &&
          video.readyState >= 2
        ) {

          video.closest(
            '.csh__media'
          )?.classList.add(
            'is-video-playing'
          );
        }


        try {

          const promise =
            video.play();


          if (promise?.catch) {

            promise.catch(
              () => {}
            );
          }

        } catch (_) {}
      }


      updateAutoplayButton() {

        if (!this.autoplayToggle) {
          return;
        }


        this.autoplayToggle
          .classList
          .toggle(
            'is-paused',
            this.userPaused
          );


        this.autoplayToggle
          .setAttribute(
            'aria-pressed',
            this.userPaused
              ? 'true'
              : 'false'
          );


        this.autoplayToggle
          .setAttribute(
            'aria-label',
            this.userPaused
              ? 'Automatischen Wechsel fortsetzen'
              : 'Automatischen Wechsel pausieren'
          );
      }


      toggleAutoplay() {

        if (!this.autoplayEnabled) {
          return;
        }


        this.userPaused =
          !this.userPaused;


        this.updateAutoplayButton();


        if (this.userPaused) {

          this.stopTimer();

        } else {

          this.startTimer();
        }
      }


      onClick(event) {

        const prev =
          event.target.closest(
            '[data-prev]'
          );


        if (
          prev &&
          this.contains(prev)
        ) {

          this.setActive(
            this.index - 1
          );

          return;
        }


        const next =
          event.target.closest(
            '[data-next]'
          );


        if (
          next &&
          this.contains(next)
        ) {

          this.setActive(
            this.index + 1
          );

          return;
        }


        const dot =
          event.target.closest(
            '[data-dot-index]'
          );


        if (
          dot &&
          this.contains(dot)
        ) {

          this.setActive(
            Number(
              dot.dataset.dotIndex
            )
          );

          return;
        }


        const autoplayToggle =
          event.target.closest(
            '[data-autoplay-toggle]'
          );


        if (
          autoplayToggle &&
          this.contains(
            autoplayToggle
          )
        ) {

          this.toggleAutoplay();
        }
      }


      onPointerDown(event) {

        if (
          event.pointerType ===
          'mouse'
        ) {
          return;
        }


        if (
          event.target.closest(
            'a, button'
          )
        ) {
          return;
        }


        this.pointerStartX =
          event.clientX;


        this.pointerStartY =
          event.clientY;
      }


      onPointerUp(event) {

        if (
          this.pointerStartX === null
          ||
          this.pointerStartY === null
        ) {
          return;
        }


        const deltaX =
          event.clientX -
          this.pointerStartX;


        const deltaY =
          event.clientY -
          this.pointerStartY;


        this.pointerStartX =
          null;


        this.pointerStartY =
          null;


        if (
          Math.abs(deltaX) < 45
          ||
          Math.abs(deltaX)
          <=
          Math.abs(deltaY)
        ) {
          return;
        }


        this.setActive(
          deltaX < 0
            ? this.index + 1
            : this.index - 1
        );
      }


      onBlockSelect(event) {

        if (!this.designMode) {
          return;
        }


        const slide =
          event.target.closest(
            '[data-slide]'
          );


        if (
          !slide ||
          !this.contains(slide)
        ) {
          return;
        }


        const index =
          Number(
            slide.dataset.index
          );


        if (
          Number.isFinite(index)
        ) {

          this.setActive(
            index,
            false
          );
        }


        this.stopTimer();
      }
    }


    customElements.define(
      'cel-split-hero',
      CelSplitHero
    );

  })();


  } catch(e) { console.error(e); }
})();
})();
